import gql from 'graphql-tag'

export default gql`
mutation UpdateConversation($input: ConversationUpdateInput!) {
  updateConversation(input: $input) {
    id,
    userId,
    userType,
    user {
      id,
      name,
      avatarId,
      photoFlag,
      email
    },
    opponentId,
    opponentType,
    opponent {
      id,
      name,
      avatarId,
      photoFlag,
      email
    },
    title,
    lastMessageId,
    updatedAt,
    unreads
  }
}`



// WEBPACK FOOTER //
// ./src/graphql/chat/mutations/update-conversation.mutation.js